import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    redirect: '/detect'
  },
  {
    path: '/detect',
    name: 'Detect',
    component: () => import('../components/DetectPanel.vue')
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../components/HistoryPanel.vue')
  },
  {
    path: '/announcements',
    name: 'Announcements',
    component: () => import('../components/AnnouncementPanel.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../components/SettingsPanel.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path === '/settings') {
    const role = localStorage.getItem('user_role');
    if (role !== 'admin') {
      alert('您没有权限访问系统管理后台。');
      return next('/detect');
    }
  }
  next();
});

export default router;
